import Vue from 'vue'

let debug
if (process.env.VUE_APP_APP_DEBUG === 'true') {
  debug = true
  Vue.config.devtools = true;
} else {
  debug = false
}

const configVariable = {
  debug: debug,
  path: {
    root: process.env.VUE_APP_APP_ROUTING_ROOT_HINA,
    root_gogatsu: process.env.VUE_APP_APP_ROUTING_ROOT_GOGATSU,
  },
  errorCode: {
    beforeRouteEnter: 100,
    beforeRouteUpdate: 200,
    nextPage: 300,
  },
}

export default {
  install () {
    Vue.prototype.config = configVariable
  }
}
